import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  DatePickerWithRange,
  Icon,
  Text,
} from '@mntn/ui-components'
import type React from 'react'
import { useFilter } from '../context/filter-context'

export const AirDatesFilter: React.FC = () => {
  const { filters, updateFilter, isSectionOpen, toggleSection } = useFilter()
  const isOpen = isSectionOpen('air-dates')

  const currentRange = filters.airDates || { start: undefined, end: undefined }
  const selectedCount = currentRange.start || currentRange.end ? 1 : 0

  const handleDateRangeChange = (range: { from?: Date; to?: Date }) => {
    if (!range.from && !range.to) {
      updateFilter('airDates', undefined)
    } else {
      updateFilter('airDates', {
        start: range.from,
        end: range.to,
      })
    }
  }

  return (
    <Accordion
      type="single"
      collapsible
      value={isOpen ? 'air-dates' : ''}
      onValueChange={() => toggleSection('air-dates')}
      className="w-full"
    >
      <AccordionItem value="air-dates" className="border-0">
        <AccordionTrigger className="p-6 border-b border-borders-primary hover:no-underline">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-2">
              <Text variant="lg-sb">Air Dates</Text>
              {selectedCount > 0 && (
                <div className="bg-primary text-header-inverse rounded-full px-2 py-1 text-xs font-medium">
                  {selectedCount}
                </div>
              )}
            </div>
            <Icon
              name={isOpen ? 'Minus' : 'Plus'}
              className="h-6 w-6 text-primary shrink-0 transition-transform duration-200"
            />
          </div>
        </AccordionTrigger>
        <AccordionContent className="p-6 border-b border-borders-primary">
          <div className="w-full">
            <DatePickerWithRange
              selected={{
                from: currentRange.start,
                to: currentRange.end,
              }}
              onChange={handleDateRangeChange}
              className="w-full"
            />
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
